import { Button } from '@chakra-ui/react'
import React from 'react'
import { FaFileExcel } from 'react-icons/fa'
import { useExcelGenerator } from '../../../hooks/useExcelGenerator'

export const GerarExcel = ({ data }) => {
  const { loading, generateExcel } = useExcelGenerator()

  async function handleGenerateExcel() {
    const params = {
      header: [
        'Data',
        'Data NF-e',
        'Nº Pedido',
        'Cliente',
        'NF-e',
        'Valor NF-e',
        'Pagamento',
        'Parcelas',
        'Valor Parcela',
        'Data Vencimento',
        'Data Pagamento',
        'Valor Real',
      ],
      dataItems: data?.map((item) => {
        return {
          data_pedido_liberado: item.data_pedido_liberado,
          data_nfe: item.data_nfe,
          numero_pedido: item.numero_pedido,
          cliente: item.cliente,
          nfe: item.nfe,
          valor_nota: item.valor_nota,
          pagamento: item.pagamento,
          parcelas: item.parcelas,
          valor_parcela: item.valor_parcela,
          data_vencimento: item.data_vencimento,
          data_pagamento: item.data_pagamento,
          valor_real: item.valor_real,
        }
      }),
      title: `Relatório de Imposto - ${new Date().toLocaleDateString()}`,
    }

    await generateExcel(params.header, params.dataItems, params.title)
  }

  return (
    <Button onClick={handleGenerateExcel} isLoading={loading} leftIcon={<FaFileExcel />} size="sm" colorScheme="green" maxW="120px" w="full">
      Gerar Excel
    </Button>
  )
}
